import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const MarketSentimentChart = () => {
  // Dummy Data
  const data = [
    { name: "Positive", y: 55, color: "#28a745" }, // Positive sentiment
    { name: "Neutral", y: 25, color: "#ffc107" }, // Neutral sentiment
    { name: "Negative", y: 20, color: "#dc3545" }, // Negative sentiment
  ];

  // Highcharts Configuration
  const options = {
    chart: {
      type: "pie", // Pie chart type
    },
    title: {
      text: "",
    },
    // subtitle: {
    //   text: "Uses sentiment analysis to monitor public perception around trending topics in the user’s industry.",
    // },
    tooltip: {
      pointFormat: "<b>{point.name}</b>: {point.percentage:.1f}% ({point.y})",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true, // Allow slice selection
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f}%", // Show percentages
        },
        showInLegend: true, // Display the legend
      },
    },
    series: [
      {
        name: "Sentiment Score",
        colorByPoint: true, // Automatically assign colors to slices
        data: data, // Pie chart data
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts watermark
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MarketSentimentChart;
